import { useState } from "react";
import axios from "axios";
import { API } from "../api";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${API}/auth/login`, { email, password });

            // Save token
            localStorage.setItem("token", res.data.token);
            // Reload to reset app state (simple auth flow)
            window.location.href = "/";

        } catch (err) {
            setError(err.response?.data?.message || "Login failed");
        }
    };



    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "var(--bg-deep)",
            position: "relative",
            overflow: "hidden"
        }}>
            {/* Background Glows */}
            <div style={{ position: "absolute", top: "20%", left: "20%", width: "400px", height: "400px", background: "var(--accent-glow)", filter: "blur(120px)", borderRadius: "50%", opacity: 0.3 }}></div>
            <div style={{ position: "absolute", bottom: "20%", right: "20%", width: "400px", height: "400px", background: "rgba(139, 92, 246, 0.3)", filter: "blur(120px)", borderRadius: "50%", opacity: 0.3 }}></div>

            <div className="glass-panel" style={{ width: "100%", maxWidth: "440px", padding: "48px", textAlign: "center", zIndex: 10 }}>
                <div style={{ marginBottom: "32px" }}>
                    <div style={{
                        width: "80px",
                        height: "80px",
                        background: "var(--bg-elevated)",
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                        border: "1px solid var(--glass-border)",
                        boxShadow: "0 8px 16px rgba(0,0,0,0.2)"
                    }}>
                        <img src="/logo.png" alt="Logo" style={{ width: "100%", height: "auto" }} />
                    </div>
                    <h2 style={{ fontSize: "2rem", fontWeight: "800", color: "#fff", marginBottom: "8px", letterSpacing: "-0.02em" }}>Welcome Back</h2>
                    <p style={{ color: "var(--text-secondary)", fontSize: "0.95rem" }}>Login to manage your SMS campaigns</p>
                </div>

                {error && (
                    <div style={{ color: "var(--danger)", background: "rgba(239, 68, 68, 0.1)", padding: "12px", borderRadius: "12px", marginBottom: "24px", fontSize: "0.9rem", border: "1px solid rgba(239, 68, 68, 0.2)" }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin} style={{ textAlign: "left" }}>
                    <div style={{ marginBottom: "20px" }}>
                        <label style={{ display: "block", marginBottom: "8px", color: "var(--text-secondary)", fontSize: "0.85rem", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.05em" }}>Email Address</label>
                        <input
                            required
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="glass-input"
                            style={{ width: "100%", height: "50px" }}
                            placeholder="admin@example.com"
                        />
                    </div>

                    <div style={{ marginBottom: "24px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                            <label style={{ color: "var(--text-secondary)", fontSize: "0.85rem", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.05em" }}>Password</label>
                            <a href="/forgot-password" style={{ color: "var(--accent-primary)", fontSize: "0.8rem", textDecoration: "none", fontWeight: "600" }}>Forgot?</a>
                        </div>
                        <input
                            required
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="glass-input"
                            style={{ width: "100%", height: "50px" }}
                            placeholder="••••••••"
                        />
                    </div>

                    <button type="submit" className="btn-primary" style={{ width: "100%", height: "52px", fontSize: "1rem" }}>
                        Sign In
                    </button>
                </form>

                <p style={{ marginTop: "32px", color: "var(--text-muted)", fontSize: "0.85rem" }}>
                    Secure Admin Access &bull; 256-bit Encryption
                </p>
            </div>
        </div>
    );
}
